import React, { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { fetchAllowedMenus } from "../Services/APIService";

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

const Profile: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menus = await fetchAllowedMenus();
        setAllowedMenus(menus);
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, []);

  return (
    <div className="wrapper">
      <Sidebar
        collapsed={isSidebarCollapsed}
        allowedMenus={allowedMenus}
        isLoading={isLoading}
      />
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <main className="content">
          <h2>Welcome To Profile</h2>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Profile;
